/// <reference path="./filepond-locales.d.ts" />
import { FilePondServerConfigProps, setOptions } from "filepond";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import { useId, useRef } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import fr from "filepond/locale/fr-fr.js";
import { Stack } from "../../Layout";
import { FormLabel } from "../_partials";
import styles from "./FileUploader.module.scss";

registerPlugin(
    FilePondPluginFileValidateSize,
    FilePondPluginFileValidateType,
    FilePondPluginImageExifOrientation,
    FilePondPluginImagePreview,
);

type FileUploaderProps = {
    accept?: React.InputHTMLAttributes<HTMLInputElement>["accept"][];
    label: string;
    locale?: "fr" | "en";
    maxFileSize: number;
    removePreviewOnUpload?: boolean;
    server: FilePondServerConfigProps["server"];
};

export function FileUploader({
    accept,
    label,
    locale = "fr",
    maxFileSize,
    removePreviewOnUpload = true,
    server,
}: FileUploaderProps) {
    const ref = useRef<FilePond>(null);
    const id = useId();

    if (locale === "fr") {
        setOptions(fr);
    }

    const acceptedFileTypes = accept?.filter((item): item is string => !!item);
    console.log({ acceptedFileTypes });

    return (
        <Stack gap={0.5}>
            <FormLabel htmlFor={id}>{label}</FormLabel>
            <FilePond
                acceptedFileTypes={acceptedFileTypes}
                allowMultiple
                // allowRemove={false}
                allowRevert={false}
                className={styles["filepond"]}
                credits={false}
                fileValidateTypeLabelExpectedTypesMap={{
                    "application/pdf": ".pdf",
                    "image/jpeg": ".jpg",
                    "image/png": ".png",
                }}
                id={id}
                imagePreviewHeight={64}
                imagePreviewMarkupShow={false}
                maxFileSize={`${maxFileSize}B`}
                maxParallelUploads={1}
                onprocessfile={(error, file) => {
                    if (error || !removePreviewOnUpload) return;
                    setTimeout(() => ref.current?.removeFile(file), 1500);
                }}
                ref={ref}
                server={server}
            />
        </Stack>
    );
}
